import React, {useState} from 'react';
import './assets/leads.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import {faCircleDot} from "@fortawesome/free-solid-svg-icons/faCircleDot";

const HorizontalTimeline = props => {

    return (
        <>
            <div className={'horizontal-timeline stage-contain'}>
                <ul className={'w100per flex mT15 mB15 pR2E'}>
                    <li className={'stage-graph-li '}>
                        <div id="pipeline" className="stage-bullet bg-green-v2"></div>
                    </li>
                    <li className={'stage-graph-li pR  minw60'}>
                        <div className="stage-graph-line bg-green-v2"></div>
                        <span id={"pipeline0"} className={' pA r0 bg-fff-imp t50per translateyminus50per cP stage-tick'}>
                            <FontAwesomeIcon icon={faCircleCheck}/>
                        </span>
                    </li>
                    <li className={'stage-graph-li pR  flex-1'}>
                        <div className="stage-graph-line bg-grey2"></div>
                        <span className={'grey-tick-complete pA r0 bg-fff-imp t50per translateyminus50per cP stage-tick'}>
                            <FontAwesomeIcon icon={faCircleDot}/>
                        </span>
                    </li>
                    <li className={'stage-graph-li pR  flex-1'}>
                        <div className="stage-graph-line bg-grey2"></div>
                        <span className={'grey-tick-complete pA r0 bg-fff-imp t50per translateyminus50per cP stage-tick'}>
                            <FontAwesomeIcon icon={faCircleDot}/>
                        </span>
                    </li>
                    <li className={'stage-graph-li pR  flex-1'}>
                        <div className="stage-graph-line bg-grey2"></div>
                        <span className={'grey-tick-complete pA r0 bg-fff-imp t50per translateyminus50per cP stage-tick'}>
                            <FontAwesomeIcon icon={faCircleDot}/>
                        </span>
                    </li>
                    <li className={'stage-graph-li pR  flex-1'}>
                        <div className="stage-graph-line bg-grey2"></div>
                        <span className={'grey-tick-complete pA r0 bg-fff-imp t50per translateyminus50per cP stage-tick'}>
                            <FontAwesomeIcon icon={faCircleDot}/>
                        </span>
                    </li>
                    <li className={'stage-graph-li pR  flex-1'}>
                        <div className="stage-graph-line bg-grey2"></div>
                        <span className={'grey-tick-complete pA r0 bg-fff-imp t50per translateyminus50per cP stage-tick'}>
                            <FontAwesomeIcon icon={faCircleDot}/>
                        </span>
                    </li>
                    <li className={'stage-graph-li pR  flex-1'}>
                        <div className="stage-graph-line bg-grey2"></div>
                        <span className={'grey-tick-complete pA r0 bg-fff-imp t50per translateyminus50per cP stage-tick'}>
                            <FontAwesomeIcon icon={faCircleDot}/>
                        </span>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default HorizontalTimeline;
